import { useEffect, useState } from "react";
import { Country, ICountry } from "country-state-city";

function useCountry() {
  const [country, setCountry] = useState<ICountry | null>(null);
  const [countryOptions, setCountryOptions] = useState<any>([]);

  let countryList = Country.getAllCountries();
  useEffect(() => {
    let options = createCountryOptions(countryList);
    setCountryOptions(options);
  }, []);

  const createCountryOptions = (countries: ICountry[]) => {
    const options = [
      {
        label: "Todos los países",
        value: "",
      },
    ];

    countries.forEach((country) => {
      options.push({
        label: country.name,
        value: country.isoCode,
      });
    });
    return options;
  };

  const handleSearchCountry = (value: string) => {
    let filtered = countryList.filter((country) => {
      return country.name
        .toLowerCase()
        .trim()
        .includes(value.toLowerCase().trim());
    });

    let options = createCountryOptions(filtered);
    setCountryOptions(options);
  };

  const handleSelectCountry = (value: string) => {
    let country = Country.getCountryByCode(value);
    if (country) {
      setCountry(country);
    } else {
      setCountry(null);
    }
  };

  return {
    country,
    countryList,
    countryOptions,
    handleSearchCountry,
    handleSelectCountry,
  };
}

export default useCountry;
